const LanguageSwitcher = {
	el: {
		root: document.querySelectorAll<HTMLElement>(".header__links--language"),
	},

	init(): void {
		let storedLang =
			localStorage.getItem("preferredLang") ||
			sessionStorage.getItem("preferredLang");
		if (!storedLang) {
			if (!storedLang) {
				const activeLangElement = document.querySelector(
					".header__links--language",
				);
				if (activeLangElement) {
					storedLang = activeLangElement.getAttribute("title") || "IS";
					localStorage.setItem("preferredLang", storedLang);
				}
			}
		}
		console.log("LanguageSwitcher.init()");
		for (const link of Array.from(
			document.querySelectorAll(".header__links--language"),
		)) {
			link.addEventListener("click", function (this: HTMLElement, event) {
				const selectedLang = this.getAttribute("title");
				localStorage.setItem("preferredLang", selectedLang);
				sessionStorage.setItem("preferredLang", selectedLang);
			});
		}
	},
};

export default LanguageSwitcher;
